export interface MealBuilderResultMessage {
  type: 'error';
  message: string;
}

export function isMealBuilderResultMessage(value: any): value is MealBuilderResultMessage {
  return value && value.type == 'error' && value.message && value.message.length;
}